import { CandlestickChart, Users, Coins, Brain, FlaskConical, Home, Landmark } from "lucide-react";
import { cn } from "@/lib/utils";

const ITEMS = [
  { id: "hub", label: "Hub", Icon: Home },
  { id: "hyperliquid", label: "Hyper", Icon: Coins },
  { id: "ctrader", label: "cTrader", Icon: CandlestickChart },
  { id: "invest", label: "Invest", Icon: Landmark },
  { id: "polymarket", label: "Poly", Icon: Users },
  { id: "cervello", label: "Cervello", Icon: Brain },
  { id: "lab", label: "Lab", Icon: FlaskConical },
];

// Navigazione mobile/tablet: la sidebar desktop compare da lg in su.
export const MobileNav = ({ section, onSelect, counts = {} }) => (
  <nav
    data-testid="mobile-bottom-nav"
    className="lg:hidden fixed bottom-0 inset-x-0 z-50 h-16 border-t border-border bg-background/95 backdrop-blur-md flex items-stretch justify-around"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    {ITEMS.map(({ id, label, Icon }) => {
      const active = section === id;
      const count = Number(counts?.[id] || 0);
      return (
        <button
          key={id}
          type="button"
          data-testid={`mobile-nav-${id}`}
          onClick={() => onSelect(id)}
          className={cn(
            "relative flex flex-1 flex-col items-center justify-center gap-1 text-[10px] uppercase tracking-[0.1em] transition-colors focus:outline-none",
            active ? "text-foreground" : "text-muted-foreground hover:text-foreground"
          )}
        >
          {active && <span className="absolute top-0 h-0.5 w-8 bg-emerald-500" />}
          <span className="relative">
            <Icon className="h-5 w-5" strokeWidth={active ? 2.2 : 1.8} />
            {count > 0 && (
              <span
                data-testid={`mobile-nav-badge-${id}`}
                className="absolute -top-1.5 -right-2.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-emerald-500 px-1 text-[9px] font-bold leading-none text-black"
              >
                {count > 99 ? "99+" : count}
              </span>
            )}
          </span>
          <span className="font-medium">{label}</span>
        </button>
      );
    })}
  </nav>
);
